import api from '../api/axiosConfig';

export const authApi = {
  login: async (username, password) => {
    try {
      const response = await api.post('/auth/signin', { username, password }, {
        loadingMessage: 'Вход в систему...',
        successMessage: 'Вход выполнен успешно'
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  register: async (userData) => {
    try {
      const response = await api.post('/auth/signup', userData, {
        loadingMessage: 'Регистрация...',
        successMessage: 'Регистрация выполнена успешно'
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  refreshToken: async (refreshToken) => {
    try {
      const response = await api.post('/auth/refresh', { refresh_token: refreshToken }, {
        silent: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getProtectedData: async () => {
    try {
      const response = await api.get('/auth/protected', {
        silent: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};